export enum TokenStatus {
    Continue,
    LoggedIn,
    OtpRequired,
    InvalidOtp,
    EstablishmentRequired,
    Error
}
